/**
 * Created by lidnl16 on 02/16/2017.
 */
module.exports = function(app) {

    app.directive('dateValidation', ["dateValidationUtility", function (dateValidationUtility) {
        return {
            restrict: "A",
            require: "ngModel",
            link: function (scope, elm, attrs, ctrl) {

                ctrl.$validators.dateValidation = function (modelValue) {
                    if (modelValue && modelValue !== undefined) {
                        var parsedDate = dateValidationUtility.parseDate(modelValue);

                        return dateValidationUtility.validateDate(parsedDate.day, parsedDate.month, parsedDate.year);
                    }
                    return true;
                };
            }
        };
    }]);

    app.directive('futureDateValidation', ["dateValidationUtility", function (dateValidationUtility) {
        return {
            restrict: "A",
            require: "ngModel",
            link: function (scope, elm, attrs, ctrl) {

                ctrl.$validators.futureDateValidation = function (modelValue) {
                    if (modelValue && modelValue !== undefined) {
                        var parsedDate = dateValidationUtility.parseDate(modelValue);

                        if (!dateValidationUtility.validateDate(parsedDate.day, parsedDate.month, parsedDate.year)) {
                            return false;
                        }

                        var now = new Date();
                        var enteredDate = new Date(parsedDate.year + '-' + parsedDate.month + '-' + parsedDate.day);

                        return (enteredDate >= now);
                    }
                    return true;
                };
            }
        };
    }]);

    app.directive('dateOfBirthValidation', ["dateValidationUtility", function (dateValidationUtility) {
        return {
            restrict: "A",
            require: "ngModel",
            link: function (scope, elm, attrs, ctrl) {

                ctrl.$validators.dateOfBirthValidation = function (modelValue) {
                    if (modelValue && modelValue !== undefined) {
                        var parsedDate = dateValidationUtility.parseDate(modelValue);

                        if (!dateValidationUtility.validateDate(parsedDate.day, parsedDate.month, parsedDate.year)) {
                            return false;
                        }

                        var now = new Date();
                        var past = new Date('1890-01-01');
                        var enteredDate = new Date(parsedDate.year + '-' + parsedDate.month + '-' + parsedDate.day);

                        return (enteredDate >= past && enteredDate < now);
                    }
                    return true;
                };
            }
        };
    }]);

    app.service('dateValidationUtility', function() {

        this.parseDate = function (modelValue) {
            var parsedDate = {};

            if (modelValue instanceof Date) {
                parsedDate.year = modelValue.getFullYear();
                parsedDate.day = modelValue.getDate();
                parsedDate.month = modelValue.getMonth() + 1;
            } else {
                parsedDate.year = modelValue.substr(4, 4);
                parsedDate.day = modelValue.substr(2, 2);
                parsedDate.month = modelValue.substr(0, 2);
            }

            parsedDate.day = (parsedDate.day && (""+parsedDate.day).length < 2) ? '0' + parsedDate.day : parsedDate.day;
            parsedDate.month = (parsedDate.month && (""+parsedDate.month).length < 2) ? '0' + parsedDate.month : parsedDate.month;

            return parsedDate;
        };

        this.validateDate = function (day, month, year) {
            if (day < 1 || day > 31) {
                return false;
            }
            if (month < 1 || month > 12) {
                return false;
            }
            if ((month == 2 || month == 4 || month == 6 || month == 9 || month == 11) && day == 31) {
                return false;
            }
            if (month == 2) {
                if (((year % 4 === 0 && year % 100 !== 0) || ( year % 400 === 0))) {
                    return ((day >= 30) ? false : true);
                } else if (day >= 29) {
                    return false;
                }
            }
            return true;
        };

    });


};
